import OQrReader from './o-qr-reader.vue';

export default OQrReader;